import React, { useEffect, useState } from "react";
import { activities } from "../constants/constants";
import UserScoreInfo from "../CommanComponents/UserScoreInfo";
import ChapterContent from "./ChapterContent";
import { useDispatch, useSelector } from "react-redux";
import { activeSectionValue } from "../redux/slice/ActiveSectionSlice";

function Chapters({ userScore, selection, title }) {
  const [activity, setActivity] = useState("");
  const [userName, setUserName] = useState("");
  const [partName, setPartName] = useState();
  const [userScoreArray, setUserScoreArray] = useState();
  const dispatch = useDispatch();
  const sectionvalue = useSelector((state) => state.section.value);
  //hser biliglerin çeker
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("postUser"));
    if (user?._id) {
      setUserName(user.username);
    }
  }, []);
  useEffect(() => {
    if (selection) {
      if (activity === null) {
        setActivity("Vocabulary");
      }
    }
  }, [selection]);
  //score bilgisin çeker
  useEffect(() => {
    const Array = userScore ? Object.values(userScore) : [];
    setUserScoreArray(Array);
  }, []);
  //name bilgisnizi ceker
  useEffect(() => {
    if (!partName) {
      setPartName(title);
    }
  }, [partName]);

  useEffect(() => {
    setActivity(sectionvalue);
  }, [sectionvalue]);

  const setSection = (activity) => {
    setActivity(activity);
    dispatch(activeSectionValue(activity));
  };

  return (
    <div className="min-h-screen p-2 md:p-6 ">
      <div className="flex gap-2">
        <div className="max-w-7xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-8 md:mb-12 ">
            <h1
              className="text-lg md:text-2xl font-bold bg-gradient-to-r
            from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-3"
            >
              {title}
            </h1>

            <div className="black [@media(min-width:1200px)]:hidden">
              <UserScoreInfo userScore={userScore} userName={userName} />
            </div>
          </div>
          <div>
            {/* bilgisayar ve tablet */}
            <div className="hidden md:block ">
              <div
                className="grid grid-cols-4 gap-2 sm:gap-3
          md:gap-4 lg:gap-6 mb-6 md:mb-8 "
              >
                {activities.map((activityItem) => (
                  <div
                    key={activityItem.id}
                    onClick={() => setSection(activityItem.id)}
                    className={`relative flex justify-center items-center group
                  cursor-pointer transition-all duration-300 transform hover:scale-105 ${
                    activity === activityItem.id
                      ? "scale-105"
                      : "hover:scale-100"
                  }`}
                  >
                    <div
                      className={`${activityItem.color} p-1 md:px-6 md:py-4 rounded-full md:rounded-full
                   text-white shadow-md w-full min-h-[70px] sm:min-h-[80px] md:min-h-[100px] `}
                    >
                      <div className="text-center flex flex-col items-center justify-center h-full">
                        <div
                          className="text-md sm:text-lg md:text-3xl mb-0 md:mb-0.5
                    transform group-hover:scale-110 transition-transform"
                        >
                          {activityItem.icon}
                        </div>
                        <h3
                          className="text-[10px] sm:text-[12px]
                      border-b-2 border-amber-400
                    md:text-[14px] font-medium leading-tight"
                        >
                          {activityItem.title}
                        </h3>
                        <p className="text-[8px] sm:text-[10px] md:text-[12px]">
                          {activityItem.tr}
                        </p>
                      </div>

                      {/* Active Indicator */}
                      {activity === activityItem.id && (
                        <div
                          className="absolute -top-0.5 -right-0.5 w-6 h-6
                      bg-yellow-400 rounded-full flex items-center justify-center shadow-lg"
                        >
                          <span className="text-md font-bold">✓</span>
                        </div>
                      )}

                      {/* Hover Effect */}
                      <div
                        className="absolute inset-0 bg-white/10 rounded-lg md:rounded-xl
                  opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* mobile kısım */}
            <div className="flex justify-center items-center md:hidden">
              <div className="flex w-80 sm:w-auto gap-4 overflow-x-auto py-3 ">
                {activities.map((activityItem) => (
                  <div
                    key={activityItem.id}
                    onClick={() => setSection(activityItem.id)}
                    className={`relative flex justify-center items-center group
                  cursor-pointer transition-all duration-300 transform hover:scale-105 ${
                    activity === activityItem.id
                      ? "scale-105"
                      : "hover:scale-100"
                  }`}
                  >
                    <div
                      className={`${activityItem.color} p-1 md:p-5 rounded-full md:rounded-full
                   text-white shadow-md w-24 h-24  `}
                    >
                      <div className="text-center flex flex-col items-center justify-center h-full">
                        <div
                          className="text-xl
                    transform group-hover:scale-110 transition-transform"
                        >
                          {activityItem.icon}
                        </div>
                        <h3
                          className="text-ld
                      border-b-2 border-amber-400
                    md:text-[14px] font-medium leading-tight"
                        >
                          {activityItem.title}
                        </h3>
                        <p className="text-[12px]">{activityItem.tr}</p>
                      </div>

                      {/* Active Indicator */}
                      {activity === activityItem.id && (
                        <div
                          className="absolute -top-0.5 -right-0.5 w-6 h-6
                      bg-yellow-400 rounded-full flex items-center justify-center shadow-lg"
                        >
                          <span className="text-md font-bold">✓</span>
                        </div>
                      )}

                      {/* Hover Effect */}
                      <div
                        className="absolute inset-0 bg-white/10 rounded-lg md:rounded-xl
                  opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="w-full h-1 bg-blue-400 mb-4"></div>
          {selection === null ? (
            <div
              className="bg-yellow-500 flex flex-col items-center justify-center p-5
             border-yellow-600 rounded-2xl text-gray-800 "
            >
              {/* İkon Bölümü */}
              <div
                className="flex h-16 w-16 md:h-20 md:w-20 lg:h-28 lg:w-28 items-center justify-center
                text-3xl md:text-5xl lg:text-7xl
                font-semibold rounded-full mb-4 bg-purple-600 p-2"
              >
                🏫
              </div>

              {/* Metin Bölümü */}
              <div className="flex flex-col items-center gap-2">
                {/* İngilizce Metin */}
                <p className="text-lg md:text-xl font-semibold tracking-wide">
                  Please select a chapter to continue
                </p>

                {/* Mor Çizgi */}
                <div className="w-full h-0.5 bg-purple-500 rounded-full my-1"></div>

                {/* Türkçe Metin */}
                <p className="text-base md:text-lg font-medium ">
                  Lütfen devam etmek için bir bölüm seçiniz.
                </p>
              </div>
            </div>
          ) : (
            <div>
              {activity && selection && (
                <ChapterContent
                  selection={selection}
                  activity={activity}
                  title={title}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Chapters;
